import React from 'react'

export const ManageSellerLocationEdit = () => {
    return (
        <div>
            
        </div>
    )
}
